// extracted by mini-css-extract-plugin
module.exports = {"titleWithIcon":"title-with-icon-module--titleWithIcon--P8NAr","titleWithIconImg":"title-with-icon-module--titleWithIconImg--3OC_X"};